import {Injectable} from "@angular/core";

import { UtilityService } from "@irb-common/services/utility.service";

@Injectable({
  providedIn: "root",
})
export class DevelopmentGuard  {
  constructor(private util: UtilityService) {}

  canActivate() {
    return this.util.getEnv() !== "PROD";
  }
}